import { Button, Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import RequeridoLabel from "../../../commons/labels/RequeridoLabel";
import { tableConfig } from "../../../commons/table/tableConfig";

const ImportarNominaErrorTable = ({
  handleGoHome,
  handleReintentarImportacionNomina,
  data,
}) => {
  const columns = useMemo(() => [
    {
      accessorKey: "cuitEmpleador",
      header: "CUIT",
    },
    {
      accessorKey: "cuilTrabajador",
      header: "CUIL",
    },
    {
      accessorKey: "matrizUnica",
      header: "Matriz Única",
    },
    {
      accessorKey: "apellidoNombre",
      header: "Apellido y Nombre",
    },
    {
      accessorKey: "tarea",
      header: "Tarea",
    },
    {
      accessorKey: "puesto",
      header: "Puesto",
    },
    {
      accessorKey: "sector",
      header: "Sector",
    },
    {
      accessorKey: "codigosRiesgo",
      header: "Cód. Riesgos",
    },
    {
      accessorKey: "fechaInicioExposicion",
      header: "Fecha Inicio Exposición",
    },
    {
      accessorKey: "fechaFinExposicion",
      header: "Fecha Fin Exposición",
    },
    {
      accessorKey: "mensaje",
      header: "Mensaje",
    },
  ], []);

  const table = useMaterialReactTable({
    columns,
    data: data || [],
    ...tableConfig,
    localization: MRT_Localization_ES,
    enableHiding: false,
    enableColumnActions: false,
    enableSorting: false,
    paginationDisplayMode: "pages",
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
    },
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25],
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === "first") return "Ir a la primera página";
        if (type === "last") return "Ir a la última página";
        if (type === "next") return "Ir a la siguiente página";
        if (type === "previous") return "Ir a la página anterior";
        return "";
      },
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} de ${count !== -1 ? count : to}`,
    },
    renderBottomToolbarCustomActions: () => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          gap: 10,
          padding: "10px 0",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleReintentarImportacionNomina}
        >
          Reintentar
        </Button>
        <Button
          style={{ color: "red", border: "1px solid red" }}
          color="quartary"
          variant="outlined"
          onClick={handleGoHome}
        >
          Salir
        </Button>
      </div>
    ),
  });

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="h6">Errores de Importación</Typography>
      </div>
      <RequeridoLabel text="La importación arrojó los siguientes errores, subsane los mismos y vuelva a intentar" />
      <div style={{ marginTop: 10 }}>
        <MaterialReactTable table={table} />
      </div>
    </div>
  );
};

export default ImportarNominaErrorTable;
